"use strict";

exports.__esModule = true;
exports.HistoricalMetricChartElement = void 0;
var _react = _interopRequireWildcard(require("react"));
var _API = require("../../API");
var _Charts = require("../../Charts");
var _Core = require("../../Core");
var _DeviceContext = require("../../Device/DeviceContext");
var _DeviceListContext = require("../../Device/DeviceListContext");
var _Metrics = require("../../Metrics");
var _Time = require("../../Time");
var _MetricChartContextMenu = require("./MetricChartContextMenu");
var _dec, _dec2, _dec3, _dec4, _dec5, _class, _HistoricalMetricChartElement;
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function _createForOfIteratorHelperLoose(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (t) return (t = t.call(r)).next.bind(t); if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var o = 0; return function () { return o >= r.length ? { done: !0 } : { done: !1, value: r[o++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _inheritsLoose(t, o) { t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
/**
 * Displays a chart for a particular metric.
 */
var HistoricalMetricChartElement = exports.HistoricalMetricChartElement = (_dec = _Core.SelectionContext.withContext, _dec2 = _Time.ReportingPeriodContext.withContext, _dec3 = _DeviceContext.DeviceContext.withContext, _dec4 = _DeviceListContext.DeviceListContext.withContext, _dec5 = _API.RestAPIContext.withContext, _dec(_class = _dec2(_class = _dec3(_class = _dec4(_class = _dec5(_class = (_HistoricalMetricChartElement = /*#__PURE__*/function (_Component) {
  function HistoricalMetricChartElement() {
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _Component.call.apply(_Component, [this].concat(args)) || this;
    _this.load = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(_ref) {
        var interval, devices, metricNames, api, queries, results;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              interval = _ref.interval, devices = _ref.devices, metricNames = _ref.metricNames;
              api = _this.props.api;
              queries = metricNames.map(function (metricName) {
                return {
                  filters: {
                    must: [{
                      filterType: "range",
                      fieldName: "timestamp",
                      values: {
                        gte: new Date(interval.startMillis),
                        lt: new Date(interval.endMillis)
                      }
                    }, {
                      filterType: "terms",
                      fieldName: "entity.device",
                      values: devices.map(function (device) {
                        return device.uuid;
                      })
                    }],
                    mustNot: []
                  },
                  bins: [{
                    binName: "by_device",
                    fieldName: "entity.device",
                    aggType: "terms",
                    options: {}
                  }, {
                    binName: "by_timestamp",
                    fieldName: "timestamp",
                    aggType: "date_histogram",
                    options: {
                      calendar_interval: "hour"
                    }
                  }],
                  metrics: [metricName]
                };
              });
              _context.n = 1;
              return Promise.all(queries.map(function (query) {
                return api.post("/api/v3/timeseries-metrics/", query);
              }));
            case 1:
              results = _context.v;
              return _context.a(2, results.reduce(function (collected, result, index) {
                var metricName = metricNames[index];
                var flattened = (0, _Metrics.flattenMetricResponse)(metricName, result);
                for (var _iterator = _createForOfIteratorHelperLoose(flattened), _step; !(_step = _iterator()).done;) {
                  var row = _step.value;
                  var key = row.timestamp;
                  var value = metricName in row ? row[metricName] : null;
                  var collectedKey = row.device + ":" + metricName;
                  if (!Array.isArray(collected[collectedKey])) {
                    collected[collectedKey] = [];
                  }
                  collected[collectedKey].push({
                    key: key,
                    value: value
                  });
                }
                return collected;
              }, {}));
          }
        }, _callee);
      }));
      return function (_x) {
        return _ref2.apply(this, arguments);
      };
    }();
    return _this;
  }
  _inheritsLoose(HistoricalMetricChartElement, _Component);
  var _proto = HistoricalMetricChartElement.prototype;
  _proto.getChartSeries = function getChartSeries(devices, results) {
    var metricChartSeries = this.props.metricChartSeries;
    var series = [];
    for (var i = 0; i < devices.length; i++) {
      var device = devices[i];
      var _loop = function _loop() {
        var _metricChartSeries$j = metricChartSeries[j],
          metricName = _metricChartSeries$j.metricName,
          seriesType = _metricChartSeries$j.seriesType;
        var key = device.uuid + ":" + metricName;
        var data = results[key];
        if (!data) {
          return 1; // continue
        }
        series.push({
          metricName: metricName,
          data: data,
          render: function render(props) {
            var SeriesComponent = getSeriesComponent(seriesType);
            return /*#__PURE__*/_react["default"].createElement(SeriesComponent, props);
          }
        });
      };
      for (var j = 0; j < metricChartSeries.length; j++) {
        if (_loop()) continue;
      }
    }
    return series;
  };
  _proto.render = function render() {
    var _this2 = this;
    var _this$props = this.props,
      metricChartSeries = _this$props.metricChartSeries,
      devices = _this$props.devices,
      device = _this$props.device,
      width = _this$props.width,
      height = _this$props.height,
      hideXAxis = _this$props.hideXAxis,
      hideYAxis = _this$props.hideYAxis,
      hideLabel = _this$props.hideLabel,
      dataRange = _this$props.dataRange,
      reportingPeriod = _this$props.reportingPeriod,
      selection = _this$props.selection;
    var metricNames = metricChartSeries.map(function (series) {
      return series.metricName;
    });
    var selectedDevices = device ? [device] : devices || [];

    // Use the selection context interval if it's required
    var targetReportingInterval = dataRange === "SELECTION" && selection && selection.selected.reportingPeriod ? selection.selected.reportingPeriod.interval : reportingPeriod.interval;
    return /*#__PURE__*/_react["default"].createElement(_Core.AsyncLoader, {
      load: this.load,
      params: {
        interval: targetReportingInterval,
        metricNames: metricNames,
        devices: selectedDevices
      }
    }, function (loaderProps) {
      return /*#__PURE__*/_react["default"].createElement(_Core.LoadingMediator, loaderProps, function (results) {
        var data = _this2.getChartSeries(selectedDevices, results);
        return /*#__PURE__*/_react["default"].createElement(_MetricChartContextMenu.MetricChartContextMenu, {
          data: data,
          width: width,
          height: height
        }, /*#__PURE__*/_react["default"].createElement(_Metrics.MetricChart, {
          width: width,
          height: height,
          showXAxis: !hideXAxis,
          showYAxis: !hideYAxis,
          yAxisWidth: hideLabel ? 35 : 65,
          showXUnits: false,
          showYUnits: !hideLabel,
          interval: targetReportingInterval,
          series: data
        }));
      });
    });
  };
  return HistoricalMetricChartElement;
}(_react.Component), _HistoricalMetricChartElement.defaultProps = {
  reportingPeriod: undefined,
  device: undefined,
  api: undefined
}, _HistoricalMetricChartElement)) || _class) || _class) || _class) || _class) || _class);
function getSeriesComponent(input) {
  switch (input) {
    case "bar":
      return _Charts.BarChartSeries;
    case "area":
      return _Charts.AreaChartSeries;
    default:
      return _Charts.LineChartSeries;
  }
}